/* CG item minimums in the cart (R46, Oct 14 2026).
   Catering items sold per person or per box with "Minimum order of 10" (or the "minimum" tag) can't be
   lowered below their minimum from the full cart or the side cart, and Check out stays blocked while any
   line is under its minimum. Trays (half/full) have no per-person minimum. Same rule the catering product
   page already uses. */
(function () {
  if (window.__cgMinQty) return; window.__cgMinQty = true;
  var MIN = {}, cartCache = null;
  function json(u) { return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }); }
  function minFor(p, variantTitle) {
    if (!p) return 1;
    var tags = (p.tags || []).join(',').toLowerCase(), desc = String(p.description || '');
    if (/tray/i.test(variantTitle || '')) return 1;
    if (tags.indexOf('minimum') > -1 || /Minimum order (of|for) 10/i.test(desc)) {
      var m = desc.match(/Minimum order (?:of|for) (\d+)/i);
      return m && +m[1] > 1 ? +m[1] : 10;
    }
    return 1;
  }
  function load() {
    return json('/cart.js').then(function (c) {
      cartCache = c;
      var need = {};
      (c.items || []).forEach(function (it) { if (/cater/i.test(it.product_type || '') && MIN[it.key] == null) need[it.handle] = 1; });
      return Promise.all(Object.keys(need).map(function (h) { return json('/products/' + h + '.js').then(function (p) { return [h, p]; }).catch(function () { return [h, null]; }); }))
        .then(function (list) {
          var byH = {}; list.forEach(function (x) { byH[x[0]] = x[1]; });
          (c.items || []).forEach(function (it) { if (byH[it.handle] !== undefined || MIN[it.key] == null) MIN[it.key] = /cater/i.test(it.product_type || '') ? minFor(byH[it.handle], it.variant_title) : 1; });
          apply();
          return c;
        });
    }).catch(function () {});
  }
  function lineAt(idx) { return cartCache && cartCache.items ? cartCache.items[idx - 1] : null; }
  function apply() {
    document.querySelectorAll('input.quantity__input[data-index]').forEach(function (inp) {
      var it = lineAt(+inp.dataset.index); if (!it) return;
      var m = MIN[it.key] || 1; if (m <= 1) return;
      inp.min = m; inp.dataset.cgMin = m;
      var minus = inp.parentNode && inp.parentNode.querySelector('button[name="minus"]');
      if (minus) { minus.classList.toggle('disabled', +inp.value <= m); minus.disabled = +inp.value <= m; }
      var row = inp.closest('.cart-item'), host = inp.closest('.cart-item__quantity-wrapper') || inp.closest('td') || (inp.parentNode && inp.parentNode.parentNode);
      if (row && host && !row.querySelector('.cg-minnote')) { var n = document.createElement('p'); n.className = 'cg-minnote'; n.textContent = 'Minimum ' + m; n.style.cssText = 'margin:.4rem 0 0;font-size:1.2rem;color:#6b6d72'; host.appendChild(n); }
    });
  }
  function under() {
    if (!cartCache) return null;
    var bad = null;
    (cartCache.items || []).forEach(function (it) { var m = MIN[it.key] || 1; if (!bad && it.quantity < m) bad = { it: it, m: m }; });
    return bad;
  }
  /* typed or stepped below the minimum: snap back up before the theme sends the change */
  document.addEventListener('change', function (e) {
    var inp = e.target; if (!inp || !inp.matches || !inp.matches('input.quantity__input')) return;
    var m = +inp.dataset.cgMin || 0; if (!m) return;
    var v = parseInt(inp.value, 10);
    if (v > 0 && v < m) { inp.value = m; }
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('quantity-input button[name="minus"]'); if (!b) return;
    var inp = b.parentNode.querySelector('input.quantity__input'); var m = inp && +inp.dataset.cgMin;
    if (m && +inp.value <= m) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  /* checkout gate */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#checkout, #CartDrawer-Checkout, button[name="checkout"]'); if (!b) return;
    var bad = under(); if (!bad) return;
    e.preventDefault(); e.stopImmediatePropagation();
    alert(bad.it.product_title + ' has a ' + bad.m + ' minimum. Raise the quantity to ' + bad.m + ' or remove it to check out.');
  }, true);
  /* re-read after any cart change, and when the side cart re-renders */
  var of = window.fetch;
  if (of && !of.__cgMin) {
    var w = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) p.then(function () { setTimeout(load, 400); }).catch(function () {});
      return p;
    };
    Object.keys(of).forEach(function (k) { w[k] = of[k]; }); w.__cgMin = true; window.fetch = w;
  }
  var mt; new MutationObserver(function () { if (!cartCache) return; clearTimeout(mt); mt = setTimeout(apply, 120); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
})();
